import React, {useState, useRef} from 'react';
import {Modal as ModalComponent, closeModal} from '../../../common/Modal.jsx';
import {Portal} from '../../../common/Portal.jsx';
import DateInput from '../../../common/DateInput.jsx';
import {FormErrors} from '../../../monitoring_report/fill/FormCollection.jsx';

import {
  project_phase_update_phases_dates_path,
} from '~/routes';

const MODAL_ID = 'phase-dates-editor-modal';

function PhaseDatesEditorModal({handleCloseModal, project_id, phases = [], setPhases, isContractModuleEnabled}) {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal();
  };

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);

    jQuery.post(project_phase_update_phases_dates_path({project_id}), jQuery(formRef.current).serialize())
      .done((res) => {
        updatePhaseDates(res)
        handleClose();
      })
      .fail((res) => {
        let responseJSON = res.responseJSON ? res.responseJSON.errors : {server: [{message: I18n.t('unexpected_error')}]};
        setErrors(responseJSON);
        setSaving(false);
      });
  };

  const updatePhaseDates = (dates) => {
    setPhases((prevPhases) =>
      prevPhases.map((phase) => {
        const updateObj = dates.find((u) => u.id === phase.id);
        return {...phase, ...(updateObj?.dates||{})};
      })
    )
  }

  return (
    <Portal
      id={MODAL_ID}
      onClose={handleClose}
      cancelLabel={I18n.t('close')}
      size='md'
      component={ModalComponent}
      {...(isContractModuleEnabled ? {
          title: I18n.t('phase_dates'),
          cssClassNameCancelButton: 'pull-right',
          hideSaveButton: true,
        } : {
          title: I18n.t('edit_phase_dates'),
          onSave: handleSave,
          saving: saving,
          saveLabel: I18n.t('update')
        }
      )}
    >
      <form ref={formRef}>
        {Object.keys(errors).length > 0 &&
          <FormErrors errors={errors} title={I18n.t('active_validation_errors')} warningLevel={'danger'}/>
        }

        {phases.map((phase, idx) => {
          return <React.Fragment key={`phase-dates-${idx}`}>
            <label>{phase.name?.[I18n.locale]}</label>

            <div style={{display: 'flex', alignItems: 'center'}}>
              <div className='form-group' style={{width: '100%'}}>
                <DateInput
                  name={`phase[${phase.id}][start_date]`}
                  defaultValue={phase.start_date}
                  placeholder={I18n.t('start_date')}
                  disabled={isContractModuleEnabled}
                />
              </div>
              <div style={{margin: '0 10px', paddingBottom: '12px'}}>-</div>
              <div className='form-group' style={{width: '100%'}}>
                <DateInput
                  name={`phase[${phase.id}][due_date]`}
                  defaultValue={phase.due_date}
                  placeholder={I18n.t('end_date')}
                  disabled={isContractModuleEnabled}
                />
              </div>
            </div>
          </React.Fragment>
        })}
      </form>
    </Portal>
  );
}

const PhaseDatesEditor = ({project_id, phases, setPhases, isContractModuleEnabled}) => {
  const [openModal, setOpenModal] = useState(false);
  const activePhases = phases.filter(v => !v.is_terminal_phase)

  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);

  return (
    <>
      <button
        className='flex-btn btn btn-sm btn-default'
        style={{position: 'absolute', right: '34px', marginTop: '-43px'}}
        onClick={handleOpenModal}
      >
        <i className={`fa fa-${isContractModuleEnabled ? "eye" : "pen"}`} />
      </button>

      {openModal &&
        <PhaseDatesEditorModal {...{handleCloseModal, project_id, phases: activePhases, setPhases, isContractModuleEnabled}}/>
      }
    </>
  );
}

export default PhaseDatesEditor;
